module.exports = __webpack_public_path__ + "img/mcy1.95e55498.gif";